import { switchFuncStrict } from 'lib/function/switchFunc'
import type SvgIcon from 'LuxKit/SvgIcon'
import { SupportedActionReward } from 'loyalty/constants/loyaltyActionRewards'
import type { ComponentProps } from 'react'
import LineShareIcon from 'LuxKit/Icons/line/LineShareIcon'
import LineCreditCardIcon from 'LuxKit/Icons/line/LineCreditCardIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'
import LineAppsIcon from 'LuxKit/Icons/line/LineAppsIcon'
import LineChatIcon from 'LuxKit/Icons/line/LineChatIcon'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import LineCalendarHeartIcon from 'LuxKit/Icons/line/LineCalendarHeartIcon'
import LineBuildingIcon from 'LuxKit/Icons/line/LineBuildingIcon'
import LineDownloadAltIcon from 'LuxKit/Icons/line/LineDownloadAltIcon'
import LineEnvelopeAltIcon from 'LuxKit/Icons/line/LineEnvelopeAltIcon'
import LineWhatsappIcon from 'LuxKit/Icons/line/LineWhatsappIcon'

/** Must define an icon component for each actionName */
const getIcon = switchFuncStrict<typeof SvgIcon, SupportedActionReward>({
  // [SupportedActionReward.LUX_PLUS_RENEWAL]: LineCrownIcon,
  [SupportedActionReward.OFFER_SHARED]: LineShareIcon,
  [SupportedActionReward.PARTNER_ACCOUNT_EARNED]: LineStarIcon,
  [SupportedActionReward.LUX_PLUS_BACKUP_PAYMENT_METHOD_ADDED]: LineCreditCardIcon,
  [SupportedActionReward.MOBILE_WIDGET_ADDED]: LineAppsIcon,
  [SupportedActionReward.TRIP_PLANNER_USED]: LineChatIcon,
  [SupportedActionReward.PHONE_NUMBER_ADDED]: LinePhoneIcon,
  [SupportedActionReward.DATE_OF_BIRTH_ADDED]: LineCalendarHeartIcon,
  [SupportedActionReward.BUSINESS_DETAILS_ADDED]: LineBuildingIcon,
  [SupportedActionReward.MOBILE_APP_DOWNLOADED]: LineDownloadAltIcon,
  [SupportedActionReward.SUBSCRIBE_TO_COMMUNICATIONS]: LineEnvelopeAltIcon,
  [SupportedActionReward.WHATS_APP_CHANNEL_JOINED]: LineWhatsappIcon,
})

interface Props extends ComponentProps<typeof SvgIcon> {
  actionName: SupportedActionReward
}

function LoyaltyActionRewardsIcon({ actionName, ...rest }: Props) {
  const Icon = getIcon(actionName)
  return <Icon {...rest} />
}

export default LoyaltyActionRewardsIcon
